module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_system_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "メール作成(送信先ユーザ)"
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "20px 0px"
    }
  }, [_c('master-user', {
    attrs: {
      "searchData": _vm.selectedUserIDs,
      "showSearch": false,
      "showDetailsButtons": false,
      "allUserIds": false,
      "showCheckBox": true,
      "subSearchMode": "only",
      "refreshTag": "selectedUsersRefresh",
      "tabStyle": "width: 100%; height: 200px"
    },
    on: {
      "selected": _vm.onSelectedUserSelected
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {}, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "min-width": "100px",
      "float": "left",
      "margin-left": "15px",
      "margin-right": "5px"
    },
    on: {
      "click": _vm.addUser
    }
  }, [_vm._v("▲ユーザ追加")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    staticStyle: {
      "min-width": "100px",
      "float": "left",
      "margin-left": "15px",
      "margin-right": "5px"
    },
    on: {
      "click": _vm.removeUsers
    }
  }, [_vm._v("ユーザ選択解除")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "20px 0px"
    }
  }, [_c('master-user', {
    attrs: {
      "showSearch": true,
      "allUserIds": true,
      "sourceState": "2",
      "searchData": _vm.selectedUserIDs,
      "subSearchMode": "ignore",
      "refreshTag": "allUsersRefresh",
      "showDetailsButtons": false,
      "showCheckBox": true,
      "tabStyle": "width: 100%; height: 200px"
    },
    on: {
      "selected": _vm.onNewUserSelected
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "margin-left": "15px",
      "float": "left"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-538cd482","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page_0081_mail_message_users.vue
// module id = 987
// module chunks = 0